import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarPortadores(api, parametros) {
    parametros.operacao = 'buscarPortadores';

    let retorno = {};

    await api.santriGET('/rest/portador', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },
  
}


// WEBPACK FOOTER //
// ./src/components/Rest/RPortador.js